import React from "react";
import BaseModal from "../../components/BaseModal";
import { MODAL_TYPES } from "../../utils/emitter";
import BaseButton from "../../components/BaseButton";
import useModalActions from "../../hooks/useModalActions";
import useBrowserStorage from "../../hooks/useBrowserStorage";
import { useTranslation } from "react-i18next";
import { ADULT_ALERT_WAS_SHOWN } from "../../utils/constants";
import config from "../../config";
import "./style.scss";

export default function AdultAlert() {
  const { closeModal } = useModalActions();
  const { setItem } = useBrowserStorage();
  const { t, i18n } = useTranslation();

  const agree = () => {
    setItem(ADULT_ALERT_WAS_SHOWN, 1);
    closeModal(MODAL_TYPES.ADULT_ALERT);
  };
  const onClose = () => {
    closeModal(MODAL_TYPES.ADULT_ALERT);
    const isInTouch =
      typeof window !== "undefined" &&
      window.location.hostname.endsWith("in-touch.space");
    if (isInTouch) {
      const url =
        i18n.language.toLowerCase() === "en"
          ? `home-${i18n.language}/?lang=${i18n.language}`
          : "?lang=" + i18n.language;
      window.location.replace(config.prod_domain + url);
    } else {
      window.location.replace(
        `${window.location.origin}/?lang=${i18n.language}`
      );
    }
  };

  return (
    <BaseModal
      preventClose
      title={t("modals.adult_alert.title")}
      className="adult-alert big-mobile-modal"
      eventTypeModal={MODAL_TYPES.ADULT_ALERT}
      contentStyle="adult-alert__actions"
    >
      <BaseButton onClick={agree}>{t("yes")}</BaseButton>
      <BaseButton
        unfilledWhite
        className="modal-button-cancel"
        negative={true}
        onClick={onClose}
      >
        {t("no")}
      </BaseButton>
    </BaseModal>
  );
}
